module.exports = require('./_global').document && document.documentElement;


//////////////////
// WEBPACK FOOTER
// ./~/core-js/library/modules/_html.js
// module id = 84
// module chunks = 483